export default (pathname) => {
  if (!pathname) {
    return
  }

  let title = pathname

  title = title.split('/')

  title = title[(title.length - 1)]

  title = title.replace(/-/g, ' ')

  title = title.replace(/l l/g, 'l-l')

  return title
}



// WEBPACK FOOTER //
// ./src/common/lib/pagetitle-from-pathname.js